import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import React from "react";
import type {
    IODataEntityDescriptor,
    IODataFilterRow,
    IODataMetadataCatalog,
} from "../declarations/ODataExplorer";
import FilterRow from "./FilterRow";

interface IFilterBuilderProps {
    catalog: IODataMetadataCatalog;
    entity: IODataEntityDescriptor;
    onChange: (rows: IODataFilterRow[]) => void;
    rows: IODataFilterRow[];
}

export default function FilterBuilder({ catalog, entity, onChange, rows }: IFilterBuilderProps) {
    const addRow = () => onChange([...rows, { id: crypto.randomUUID(), property: "", operator: "eq", value: "" }]);
    const updateRow = React.useCallback((id: string, next: IODataFilterRow) => {
        onChange(rows.map((r) => r.id === id ? next : r));
    }, [rows, onChange]);
    const removeRow = React.useCallback((id: string) => {
        onChange(rows.filter((r) => r.id !== id));
    }, [rows, onChange]);

    return (
        <Stack spacing={1}>
            {rows.map((row) => (
                <FilterRow
                    catalog={catalog}
                    entity={entity}
                    key={row.id}
                    onChange={updateRow}
                    onRemove={removeRow}
                    row={row}
                />
            ))}
            <Button onClick={addRow} startIcon={<AddIcon />} sx={{ alignSelf: "flex-start" }} variant="outlined">
                Add filter
            </Button>
        </Stack>
    );
}
